module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAMRJREFUeAHFlIENgjAQRX+NA8gGjKAb6AS4gW5inEjdgBHcoGwAG5z/EmoIUtJrIL7k5wKkr224FlgLEbkwrdjxOjZ43EDoWd7MCzYq5uicK8YrVK4womN0YHjeYGG2mJ61ZLlNfGq4tTusQlIye2Y3FjJ2IVdRsxyQQWyFYdsxOk7aJQspO7M8MCNkimQhZ39SesK8EMnCXlojA2vbBKLtY22brxCR9lm8bVY9evrnqsE5T0Vvm+bnbX9reLHT5txS/+MDNHy1/Izm8jkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journalArticles.png
// module id = 7rEY
// module chunks = 1